<clp-popup
  [showModal]="showModal"
  [title]="notification?.title ?? ''"
  [message]="notification?.message ?? ''"
  [description]="notification?.description ?? null"
  (closeModalEvent)="close()">
</clp-popup>
